import localStore from "@/global/store/local-store";
import { request } from "@/global/config/request";
import { AxiosResponse } from "axios";

export function saveUcs(data: any, params?: {}): Promise<AxiosResponse<any>> {

    const projectUuid = localStore.projectId
    data = {
        ...data,
        projectId: projectUuid
    }
    return request.post(`/projects/${projectUuid}/ucs`, data, {
        params: {
            ...params,
        }
    })
}


export function findUcsInProject(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return request.get(`/projects/${projectUuid}/ucs`, {
        params: {
            ...params,
        }
    })
}

export function deleteUcs(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return request.delete(`/ucs/${uuid}`, {
        params: {
            ...params,
            projectId: localStore.projectId,
        }
    })
}

// export function updateUcs(data: any, params?: {}): Promise<AxiosResponse<any>> {
//     const modelId = localStore.modelId
//     return request.put(`/models/${modelId}/ucs`, data, {
//         params: {
//             ...params,
//         }
//     })
// }

export function findUcsByUuid(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return request.get(`/ucs/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function findGlobalUcs(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return request.get(`/projects/${projectUuid}/global-ucs`, {
        params: {
            ...params,
        }
    })
}

export function deleteUcsMulti(uuids: string[], params?: {}): Promise<AxiosResponse<any>> {
    return request.post(`/ucs/delete-multi`, uuids, {
        params: {
            ...params,
        }
    })
}
